module.exports = {"noContact":"No manager contact number available.","sendFailed":"Failed to send the message.","sendSuccess":"The message has been sent."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/sms.json
// module id = 5HeG
// module chunks = 2